/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { useWhoAmI } from '@api/get-whoami';
import { AREC_ORGANIZATION_IDS } from '@config/constants/organizations';
import { queryClient } from '@lib/react-query';
import { useNavigate } from 'react-router';

/* -------------------------------------------------------------------------- */
/*                                  Hook                                      */
/* -------------------------------------------------------------------------- */
export const useLogout = () => {
	const navigate = useNavigate();

	const { data: cachedUser } = useWhoAmI();

	return () => {
		localStorage.removeItem('user');
		queryClient.clear();
		if (
			Object.values(AREC_ORGANIZATION_IDS).includes(
				cachedUser?.organization || ''
			)
		) {
			navigate('/arec/login');
		} else {
			navigate('/login');
		}
	};
};
